import React, { Component } from 'react';
import { connect } from 'react-redux';
import ImageLayout from './ImageLayout';
import TextOnlyLayout from './TextOnlyLayout';
import VideoLayout from './VideoLayout';
import TwoColumnLayout from './TwoColumnLayout';
import TwoColumnMiniPics from './TwoColumnMiniPics';
import Title from './Title';
import TextImageSammy from './TextImageSammy';
import LessonComplete from './LessonComplete';
import DecisionLayout from './DecisionLayout';
import ProgressBar from '../Progress/ProgressBar';
import ChooseNext from './ChooseNextPage';
import Header from '../Header/Header';
class LayoutPicker extends Component {
    render(){
        let layoutNumber = this.props.activeScene.layoutNumber;
        let completedPercent = ((parseInt(this.props.activeScene.scene_number)/Object.keys(this.props.lessonData).length) * 100).toFixed(2);
        return(
            <div>
                <Header/>
                {this.props.activeScene.scene_number !== "1" && <div className="flex-box flex-end">
                   <div className="column-lg-3 column-md-3 column-sm-3">
                    <ProgressBar completed={completedPercent}/>
                    </div>
              </div>}
                {this.props.activeScene.audio && this.props.activeScene.audio.length !== 0 && 
                <div className="flex-box">
                    <div className="flex-column audio-div flex-box">
                        <p>Listen to the sounds of this scene</p>
                        <audio src={this.props.activeScene.audio[0]} controls autoPlay loop></audio>
                    </div>
                    </div>}
                {layoutNumber === 1 && <ImageLayout history={this.props.history}/>}
                {layoutNumber === 2 && <TwoColumnLayout history={this.props.history}/>}
                {layoutNumber === 3 && <Title history={this.props.history}/>}
                {layoutNumber === 4 && <TextOnlyLayout history={this.props.history}/>}
                {layoutNumber === 5 && <TwoColumnMiniPics history={this.props.history}/>}
                {layoutNumber === 6 && <LessonComplete history={this.props.history}/>}
                {layoutNumber === 7 && <TextImageSammy history={this.props.history}/>}
                {layoutNumber === 8 && <VideoLayout history={this.props.history}/>}
                {layoutNumber === 9 && <DecisionLayout history={this.props.history}/>}
                {layoutNumber === 10 && <ChooseNext history={this.props.history}/>}
            </div>
        );
    }
}


const mapStateToProps = state => ({
    activeScene: state.activeScene,
    checkpointData: state.checkpointData,
    lessonData: state.lessonData
})
export default connect(mapStateToProps)(LayoutPicker);